import { gql } from "@apollo/client";

const teamEffortReportDataFields = `
communication
planning
production
review
`;

export { teamEffortReportDataFields };